import React from 'react';
import PropTypes from 'prop-types';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import { ContextRow, ContextLabel, ContextValue } from '../styles';

const ContextField = ({ label, value }) => (
  <ContextRow>
    <ContextLabel>{intl.formatMessage(label)}</ContextLabel>
    <ContextValue>{value}</ContextValue>
  </ContextRow>
);

ContextField.propTypes = {
  label: PropTypes.object.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ContextField;
